export default __webpack_public_path__ + "static/media/rnr-sports-table-13.5384c505.webp";